import { render, staticRenderFns } from "./program-card.vue?vue&type=template&id=676ea97a&"
import script from "./program-card.vue?vue&type=script&lang=js&"
export * from "./program-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports